import { PaymentElement } from '@stripe/react-stripe-js';
import {
	PaymentBlock,
	PaymentElementShell,
	PaymentElementWrap,
	PaymentSkeleton,
	SkeletonField,
	SkeletonFieldRow,
	SkeletonInput,
	SkeletonLabel,
	SkeletonTab,
	SkeletonTabs,
} from './PlanPayment.styles';

const PaymentElementField = ({ options, isReady, onReady }) => (
	<PaymentBlock>
		<PaymentElementShell>
			{!isReady && (
				<PaymentSkeleton aria-hidden='true'>
					<SkeletonTabs>
						<SkeletonTab />
						<SkeletonTab />
						<SkeletonTab />
						<SkeletonTab />
					</SkeletonTabs>
					<SkeletonField>
						<SkeletonLabel />
						<SkeletonInput />
					</SkeletonField>
					<SkeletonFieldRow>
						<SkeletonField>
							<SkeletonLabel />
							<SkeletonInput />
						</SkeletonField>
						<SkeletonField>
							<SkeletonLabel />
							<SkeletonInput />
						</SkeletonField>
					</SkeletonFieldRow>
				</PaymentSkeleton>
			)}
			<PaymentElementWrap $ready={isReady}>
				{options && <PaymentElement options={options} onReady={onReady} />}
			</PaymentElementWrap>
		</PaymentElementShell>
	</PaymentBlock>
);

export default PaymentElementField;
